<template>
  <div>
    <ThreeMonthsCampaignA
      v-if="variant=== 'A'"
      :legacyCar="legacyCar"
    />
    <ThreeMonthsCampaignB
      v-if="variant=== 'B'"
      :legacyCar="legacyCar"
    />
  </div>
</template>
<script>
export default {
  name: 'ThreeMonthsCampaign',
  components: {
    ThreeMonthsCampaignA: () => import('./ThreeMonthsCampaignA.vue'),
    ThreeMonthsCampaignB: () => import('./ThreeMonthsCampaignB.vue')
  },
  props: {
    variant: { type: String, default: 'A' },
    legacyCar: { type: Boolean, default: false }
  }
}
</script>
